module.exports = __webpack_public_path__ + "static/coffee-fd698e506c5aa127bba4b3a5df31b807.mp4";